/**
 * Region name → URL slug. Mirror of the backend `src/lib/region-slug.ts`
 * `slugifyRegionName`: the dashboards `/r/:slug/*` routes resolve a region by
 * slugifying its NAME (there is no stored slug column), so the client derives
 * the identical slug to link an RD to their own region's dashboard.
 *
 * Keep this in lock-step with the backend implementation.
 */
export function slugifyRegionName(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '') // strip combining marks
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
